var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "dashboard-designer cdsp_dashboard",
      style: _vm.dashboardStyle,
    },
    [
      !_vm.previewFlag
        ? _c(
            "div",
            { staticClass: "action-panel-container" },
            [
              _c("action-panel", {
                attrs: {
                  showPublishBtn: _vm.showPublishBtn,
                  showShareBtn: _vm.showShareBtn,
                  mode: _vm.mode,
                  gridLayout: _vm.layoutObj,
                  previewFlag: _vm.previewFlag,
                },
                on: {
                  "on-export-img": _vm.handleExportImage,
                  "toggle-preview": _vm.handleTogglePreview,
                  "on-submit": _vm.handleSubmit,
                  "on-preview": _vm.onPreview,
                  "on-share": _vm.onShare,
                  "on-cancel": _vm.onCancel,
                },
                model: {
                  value: _vm.isPc,
                  callback: function ($$v) {
                    _vm.isPc = $$v
                  },
                  expression: "isPc",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.getPreviewFlag,
              expression: "!getPreviewFlag",
            },
          ],
          staticClass: "components-panel-container",
        },
        [
          _c("components-panel", {
            attrs: {
              chartConfigHandler: _vm.chartConfigHandler,
              classifyList: _vm.classifyList,
              mode: _vm.mode,
              widgets: _vm.widgetsView,
            },
            on: {
              drag: _vm.componentsPanelDrag,
              dragend: _vm.componentsPanelDragend,
              "tab-change": _vm.handleTabChange,
              "click-add": _vm.handleClickAdd,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.getPreviewFlag && !_vm.isEmptyLayout,
              expression: "!getPreviewFlag && !isEmptyLayout",
            },
          ],
          staticClass: "setting-panel-container",
        },
        [
          _c("setting-panel", {
            attrs: {
              getDwsData: _vm.getDwsData,
              custom_updateData: _vm.custom_updateData,
              globalConfig: _vm.globalConfig,
              selectItem: _vm.selectItem,
              hideGauge: _vm.hideGauge,
            },
            on: {
              "preview-detail": _vm.previewDetail,
              "on-update-single-chart": _vm.handleUpdateSingleChart,
              updateDashboard: _vm.updateDashboard,
              "panel-toggle": _vm.handlePanelToggle,
              updateFetchData: _vm.updateFetchData,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      !_vm.previewDialogVisible
        ? _c(
            "div",
            { staticClass: "canvas-panel-container" },
            [
              !_vm.isPc
                ? _c(
                    "mobile-preview",
                    [
                      _c("canvas-panel", {
                        ref: "grid",
                        attrs: {
                          chartConfigHandler: _vm.chartConfigHandler,
                          gridLayout: _vm.mobileLayout,
                          previewFlag: _vm.previewFlag,
                        },
                        on: {
                          "sort-change": _vm.handleSortChange,
                          "handle-table-command": _vm.handleTableCommand,
                          "table-page-change": _vm.handleTablePageChange,
                          "update:gridLayout": function ($event) {
                            _vm.mobileLayout = $event
                          },
                          "update:grid-layout": function ($event) {
                            _vm.mobileLayout = $event
                          },
                          chartSelect: _vm.handleChartSelect,
                        },
                      }),
                    ],
                    1
                  )
                : _c("canvas-panel", {
                    ref: "grid",
                    attrs: {
                      dashboardName: _vm.layoutObj.dashboardName,
                      chartDirection: _vm.chartDirection,
                      chartPreviewMode: _vm.chartPreviewMode,
                      previewMode: _vm.previewMode,
                      chartConfigHandler: _vm.chartConfigHandler,
                      chartData: _vm.selectItem,
                      gridLayout: _vm.layoutObj.layout,
                      previewFlag: _vm.previewFlag,
                    },
                    on: {
                      "sort-change": _vm.handleSortChange,
                      "drill-item-click": _vm.handleDrillItemClick,
                      "handle-table-command": _vm.handleTableCommand,
                      "table-page-change": _vm.handleTablePageChange,
                      "update:gridLayout": function ($event) {
                        return _vm.$set(_vm.layoutObj, "layout", $event)
                      },
                      "update:grid-layout": function ($event) {
                        return _vm.$set(_vm.layoutObj, "layout", $event)
                      },
                      chartSelect: _vm.handleChartSelect,
                      "grid-resize": _vm.handleGridResize,
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.exportingImage,
              expression: "exportingImage",
            },
          ],
          attrs: {
            visible: _vm.previewDialogVisible,
            fullscreen: "",
            "append-to-body": "",
            "close-on-click-modal": false,
            "element-loading-text": "导出中，请稍候…",
            "element-loading-spinner": "el-icon-loading",
            "element-loading-background": "rgba(255, 255, 255, 1)",
            "custom-class": "jzliu_bi_engine_preview-full-dialog",
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { height: "100%" } }, [
            _c("div", { staticClass: "jzliu-preview-header" }, [
              _c("div", [
                _c("span", [_vm._v(_vm._s(_vm.layoutObj.dashboardName))]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-button",
                    { attrs: { size: "small" }, on: { click: _vm.onBack } },
                    [_vm._v("返回编辑")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function ($event) {
                          return _vm.handleSubmit("save")
                        },
                      },
                    },
                    [_vm._v("保存")]
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                ref: "previewContainer",
                staticStyle: {
                  height: "calc(100% - 50px)",
                  "overflow-y": "auto",
                },
              },
              [
                _vm.previewDialogVisible
                  ? _c("preview", {
                      ref: "previewComponent",
                      attrs: {
                        layoutObj: {
                          layout: _vm.layoutObj.layout,
                          dashboardName: _vm.layoutObj.dashboardName,
                        },
                        widgets: _vm.widgetsView,
                      },
                      on: {
                        "sort-change": _vm.handleSortChange,
                        "drill-item-click": _vm.handleDrillItemClick,
                        "handle-table-command": _vm.handleTableCommand,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }